// extracted by mini-css-extract-plugin
module.exports = {"detail":"screw-detail_detail_1OnGW","listWrap":"screw-detail_listWrap_3myqh"};